import { useEffect, useRef, useState } from 'react'
import Style from './style.module.css';
import { useApiCall } from '../../../component/custom-hooks/api-call';
import Grid1Icon from '../../../component/icons/grid1';
import FilterTabsPopup from '../../../component/table/filter-table';
import { Link } from 'react-router';
import DataNotFound from '../../../component/ui/loader/data-not-found';
import InnerLoader from '../../../component/ui/loader/inner-loader';
import { Skeleton } from '@mui/material';
import EmployeeDirectoryAddUpdate from './add-update';
import { motion, AnimatePresence } from "framer-motion";
import FilterFunnel01Icon from '../../../component/icons/filter-funnel-01';
import ListIcon from '../../../component/icons/list';
import Edit2Icon from '../../../component/icons/edit-2';
import SortIcon from './component/sortIcon';
import LayoutGridLineIcon from '../../../component/icons/layout-grid-line';
import UserSquareIcon from '../../../component/icons/user-square';
import CustomizeTabsPopup from '../../../component/table/customize-table';
import LayoutTopIcon from '../../../component/icons/layout-top';
import Tooltip from '../../../component/ui/tooltip';
import { CustomDropdown } from '../../../component/ui/dropdown/CustomDropdown';
import { CustomDropdownButton } from '../../../component/ui/dropdown/CustomDropdownButton';
import { CustomDropdownMenu } from '../../../component/ui/dropdown/CustomDropdownMenu';
import { CustomDropdownMenuList } from '../../../component/ui/dropdown/CustomDropdownMenuList';
import { CustomDropdownMenuDivider } from '../../../component/ui/dropdown/CustomDropdownMenuDivider';
import DotsVerticalIcon from '../../../component/icons/dots-vertical';
import PlusIcon from '../../../component/icons/plus';
import ChevronDownIcon from '../../../component/icons/chevron-down';
import FileCode1Icon from '../../../component/icons/file-code-1';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import XCloseIcon from '../../../component/icons/x-close';
import EmployeeUpdateBulk from './bulk-edit';
import { Eye, Pencil, IdCard } from "lucide-react";
import EmployeeQuickView from './profile/popup';
import MainTable from '../../../component/ui/table/main-table';

const tableFilter = [
    "search_by_name",
    "search_by_salary",
    "search_by_department",
    "search_by_designation",
    "search_by_joining_date",
    "search_by_emp_type",
    "search_by_emp_status",
    "search_by_phone",
];
const OrganizationEmployeeDirectory = () => {

    const [layout, setLayout] = useState("list");
    const [tableLoader, setTableLoader] = useState(false);
    const [tablePagination, setTablePagination] = useState({});
    const [userData, setUserData] = useState([]);
    const [showModalFilterTable, setShowModalFilterTable] = useState(false);
    const [btnLoader, setBtnLoader] = useState(false);
    const apiCall = useApiCall();
    const [addUser, setAddUser] = useState(false);
    const [addUserData, setAddUserData] = useState({});

    // PAGINATION AND FILTER CODE

    const [filterReturn, setFilterReturn] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [pageItemsCount, setPageItemsCount] = useState(10);
    const [sortFields, setSortFields] = useState([]);

    // CUSTOMIZ SHOW HEADER

    const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
    const [tableHeader, setTableHead] = useState([]);
    const [saveFilter, setSaveFilter] = useState([]);

    const openAddUserData = (ele) => { setAddUserData(ele); setTimeout(() => { setAddUser(true) }, 100); }

    useEffect(() => { filterData({}); }, [])

    const handleSingleSort = (field) => {
        setSortFields((prev) => {
            let currentSort = prev[0]; // Assume prev is an array with max 1 object
            let newSortField;
            if (currentSort && currentSort.field === field) {
                if (currentSort.order === 'desc') { newSortField = { field, order: 'asc' }; } else if (currentSort.order === 'asc') { newSortField = null; }
            } else {
                newSortField = { field, order: 'desc' };
            }
            const finalSortFields = newSortField ? [newSortField] : [];
            // Trigger the filter with the updated sort
            filterData({ sortField: finalSortFields });
            return finalSortFields;
        });
    };

    const filterData = ({ filters = filterReturn, page = pageCount, page_quantity = pageItemsCount, sortField = sortFields, btnCall = false }) => {
        const sort_by = sortField[0]?.field || null;
        const sort_direction = sortField[0]?.order || null;
        const data = { page, page_quantity, filters, sort_by, sort_direction, btnCall };
        dataGetFuntion(data);
    };

    const dataGetFuntion = async (data = null) => {
        if (data?.btnCall) { setBtnLoader(true) } else { setTableLoader(false); }
        let urlData = `?page_quantity=10&page=1`;
        if (data) {
            urlData = `?page=${data?.page}${(data?.page_quantity !== 'all') ? `&page_quantity=${data?.page_quantity}` : ''}`;
            if (data?.filters) {
                data?.filters.forEach((el) => {
                    if (el.field === 'search_by_salary' && Array.isArray(el.value)) {
                        if (el.value[0]) {
                            urlData += `&search_by_salary=${el.value[0]}`;
                        }
                        if (el.value[1]) {
                            urlData += `-${el.value[1]}`;
                        }
                    } else {
                        urlData += `&${el.field}=${el.value}`;
                    }
                });
            }
            if (data?.sort_by && data?.sort_direction) {
                urlData += `&sort_by=${data.sort_by}&sort_direction=${data.sort_direction}`;
            }
        }
        try {
            let res = await apiCall({ url: `get-all-employees${urlData}`, method: 'get' });
            setTableHead(res?.headers)
            setTablePagination(res?.pagination);
            setSaveFilter(res?.custom_filters)
            setTableLoader(true);
            if (data?.btnCall) {
                setBtnLoader(false);
                setUserData((prev) => [...prev, ...res.active_users]);
            } else {
                setUserData(res.active_users);
            }
        } catch (error) {
            console.warn("Err", error);
        }
    };

    const tableRef = useRef(null);
    const [exportTo, setExportTo] = useState(false);

    const handleExport = async (type) => {
        const filters = filterReturn;
        const sortField = sortFields;
        const page = 1;
        const page_quantity = 'all';
        const sort_by = sortField[0]?.field || null;
        const sort_direction = sortField[0]?.order || null;
        const data = { page, page_quantity, filters, sort_by, sort_direction };

        // Show loading modal
        Swal.fire({
            title: 'Exporting...',
            text: 'Please wait while we export your data.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        // Build query string
        let urlData = `?page=${data.page}`;
        if (data.page_quantity !== 'all') {
            urlData += `&page_quantity=${data.page_quantity}`;
        }
        if (data.filters?.length) {
            data.filters.forEach((el) => {
                if (el.field === 'search_by_salary' && Array.isArray(el.value)) {
                    if (el.value[0]) urlData += `&search_by_salary=${el.value[0]}`;
                    if (el.value[1]) urlData += `-${el.value[1]}`;
                } else {
                    urlData += `&${el.field}=${el.value}`;
                }
            });
        }
        if (data.sort_by && data.sort_direction) {
            urlData += `&sort_by=${data.sort_by}&sort_direction=${data.sort_direction}`;
        }

        try {
            const res = await apiCall({ url: `get-all-employees${urlData}`, method: 'get' });
            const userDd = res?.active_users;
            const headers = res?.headers?.filter(h => h.is_visible);

            if (!userDd?.length) {
                return Swal.fire({
                    title: 'Warning!',
                    text: 'No data available to export.',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: Style.customSwalBtn
                    }
                });
            }

            const fileName = `users_${new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-")}`;
            const visibleKeys = headers.map(h => h.key);
            const visibleLabels = headers.map(h => h.value);

            const cleanData = userDd.map(row => {
                const cleaned = {};
                visibleKeys.forEach(key => {
                    cleaned[key] = row[key];
                });
                return cleaned;
            });

            if (type === 'csv') {
                const csvRows = [
                    visibleLabels.join(','),
                    ...cleanData.map(row =>
                        visibleKeys.map(key => {
                            const cell = row[key] ?? '';
                            const clean = ('' + cell).replace(/"/g, '""');
                            return `"${clean}"`;
                        }).join(',')
                    )
                ];
                const csvContent = "\uFEFF" + csvRows.join('\n');
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", `${fileName}.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

            if (type === 'excel') {
                const exportData = cleanData.map(row => {
                    const obj = {};
                    visibleKeys.forEach((key, i) => {
                        obj[visibleLabels[i]] = row[key];
                    });
                    return obj;
                });
                const ws = XLSX.utils.json_to_sheet(exportData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Users");
                XLSX.writeFile(wb, `${fileName}.xlsx`);
            }

            Swal.fire({
                title: 'Success!',
                text: 'Data has been exported successfully.',
                icon: 'success',
                confirmButtonText: 'OK',
                buttonsStyling: false,
                customClass: {
                    confirmButton: Style.customSwalBtn
                }
            });

        } catch (error) {
            console.warn("Export Error:", error);
            Swal.fire({
                title: 'Error!',
                text: 'Something went wrong while exporting.',
                icon: 'error',
                confirmButtonText: 'OK',
                buttonsStyling: false,
                customClass: {
                    confirmButton: Style.customSwalBtn
                }
            });
        }
    };

    const [empPopup, setEmpPopup] = useState(false);
    const [empData, setEmpData] = useState({});
    const showEmpPopup = (dta) => {
        setEmpData(dta);

        setTimeout(() => {
            setEmpPopup(true)
        }, 100);
    }

    // COLOUMN SELECT ALL SELECT
    const [selectedIds, setSelectedIds] = useState([]);
    const masterCheckboxRef = useRef();

    const handleToggleAll = () => {
        const allIds = userData.map((ele) => ele.employee_id);
        const isAllChecked = selectedIds?.length === allIds?.length;
        setSelectedIds(isAllChecked ? [] : allIds);
    };

    const handleToggleOne = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
        );
    };

    const [bulkDataChange, setBulkDataChange] = useState(false);
    const [bulkDatavalue, setBulkDatavalue] = useState('');

    const bulkSelectChange = (e) => {
        setBulkDatavalue(e)
        if (!e) { return }

        if (e == 'changeData') {
            setBulkDataChange(true);
        }
    }

    // Handle indeterminate state
    useEffect(() => {
        const master = masterCheckboxRef.current;
        if (!master) return;
        const total = userData?.length;
        const selected = selectedIds?.length;
        master.checked = selected === total;
        master.indeterminate = selected > 0 && selected < total;
    }, [selectedIds, userData]);

    const removeFilter = (fIndex) => {
        let allFilter = [...filterReturn];
        allFilter.splice(fIndex, 1)
        setFilterReturn(allFilter);
        filterData({ filters: allFilter, page: 1 });
    }

    const [selectFilterName, setSelectFilterName] = useState('My Filter')
    const [editingFilters, setEditingFilters] = useState(null)

    return (
        <>
            <div className={Style.mainBody}>
                <div className={Style.teamSpaceDashboard}>
                    <div className={Style.teamSpaceDashboard_main}>
                        <div className={Style.teamSpaceDashboard_body}>
                            {filterReturn?.length ?
                                <div className={Style.filterContainer}>
                                    <p className={Style.searchText}>Search By</p>
                                    {filterReturn?.map((eachFilter, i) => {
                                        return (
                                            <div className={Style.eachFilter} key={i}>
                                                <p onClick={() => { setShowModalFilterTable(true) }}>
                                                    <span>{eachFilter?.field?.replace("search_by_", "").replaceAll("_", " ")} : </span>
                                                    <b>{eachFilter?.selectedOperator}</b>
                                                    <em>
                                                        {
                                                            (typeof eachFilter?.value == "string") ?
                                                                eachFilter?.value
                                                                :
                                                                eachFilter?.value?.map((eachVal, index) => {
                                                                    return (
                                                                        `${eachVal} ${(eachFilter?.value?.length - 1 != index) ? "& " : ""}`
                                                                    )
                                                                })
                                                        }

                                                    </em>
                                                </p>

                                                <span className={Style.searchClosedBtn} onClick={() => { removeFilter(i) }}>
                                                    <div className={Style.icon}>
                                                        <XCloseIcon />
                                                    </div>
                                                </span>
                                            </div>
                                        )
                                    })}
                                </div>
                                :
                                null
                            }
                            {/* HEADER */}
                            <div className={Style.empDirectory_header}>
                                <div className={Style.empDirectory_header_left}>
                                    <div className={Style.bpfl_select}>
                                        <select onChange={(e) => { filterData({ page_quantity: e?.target.value, page: 1 }); setPageCount(1); setPageItemsCount(e?.target.value); }}>
                                            <option value="10">Employee View 10</option>
                                            <option value="25">Employee View 25</option>
                                            <option value="50">Employee View 50</option>
                                            <option value="100">Employee View 100</option>
                                            <option value="all">Employee View all</option>
                                        </select>
                                    </div>
                                    

                                    {
                                        (selectedIds?.length && layout == 'list') ? (
                                            <motion.div
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                className={Style.bpfl_select}
                                            >
                                                <select
                                                    value={bulkDatavalue}
                                                    onChange={(e) => { bulkSelectChange(e.target.value) }}
                                                >
                                                    <option value="" disabled>Action</option>
                                                    <option value="changeData">Change data</option>
                                                    <option value="sendBulkEmail" disabled>Send bulk email</option>
                                                    <option value="sendBulkLetter" disabled>Send Bulk letter</option>
                                                </select>
                                            </motion.div>
                                        ) : null
                                    }
                                </div>

                                <div className={Style.empDirectory_header_right}>
                                    <div className={Style.bpfl_action}>
                                        <div className={Style.bpfl_actionItems}>
                                            <div className={`${Style.bpfl_actionBtn} ${Style.addBtn}`} onClick={() => { setAddUser(true) }}>
                                                <div className={Style.icon}>
                                                    <PlusIcon />
                                                </div>
                                            </div>
                                        </div>

                                        <div className={Style.bpfl_actionItems}>
                                            <div className={`${Style.bpfl_actionBtn} ${(filterReturn?.length) ? Style.active : null}`} onClick={() => { setShowModalFilterTable(true); }}>
                                                <div className={Style.icon}>
                                                    <FilterFunnel01Icon />
                                                </div>
                                            </div>
                                        </div>

                                        <div className={Style.bpfl_actionItems}>
                                            <div className={Style.bpfl_actionList}>
                                                <div className={`${Style.icon} ${((layout === "list") ? Style.active : null)}`} onClick={() => setLayout("list")}><ListIcon /></div>
                                                <div className={`${Style.icon} ${((layout === "grid") ? Style.active : null)}`} onClick={() => setLayout("grid")}><Grid1Icon /></div>
                                                <div className={`${Style.icon} ${((layout === "grid2") ? Style.active : null)}`} onClick={() => setLayout("grid2")}><LayoutGridLineIcon /></div>
                                            </div>
                                        </div>

                                        <div className={`${Style.bpfl_action} ${(layout === 'list') ? null : Style.disabled}`} >
                                            <Tooltip className={`${Style.bpfl_actionItems}`} content={"Customize Table"} position={'left center'}>
                                                <div className={`${Style.bpfl_actionBtn}`} onClick={() => { setShowModalCustomizeTabs(true) }}>
                                                    <div className={Style.icon}>
                                                        <LayoutTopIcon />
                                                    </div>
                                                </div>
                                            </Tooltip>
                                        </div>

                                        <CustomDropdown position="bottom-right" className="myDropdown">
                                            <CustomDropdownButton arrow={false} className="btnClass">
                                                <DotsVerticalIcon />
                                            </CustomDropdownButton>

                                            <CustomDropdownMenu>
                                                <CustomDropdownMenuList onClick={() => setLayout("list")}>
                                                    <div className={"d-flex align-items-center gap-1"}><ListIcon /> List View</div>
                                                </CustomDropdownMenuList>
                                                <CustomDropdownMenuList onClick={() => setLayout("grid")}>
                                                    <div className={"d-flex align-items-center gap-1"}><Grid1Icon /> Grid View</div>
                                                </CustomDropdownMenuList>
                                                <CustomDropdownMenuList onClick={() => setLayout("grid2")}>
                                                    <div className={"d-flex align-items-center gap-1"}><LayoutGridLineIcon /> Card View</div>
                                                </CustomDropdownMenuList>
                                                <CustomDropdownMenuDivider />
                                                <CustomDropdownMenuList disabled={(layout === 'list') ? false : true} onClick={() => { setShowModalCustomizeTabs(true) }}>
                                                    <div className={"d-flex align-items-center gap-1"}><LayoutTopIcon /> Customize Table</div>
                                                </CustomDropdownMenuList>
                                                <CustomDropdownMenuDivider />

                                                <CustomDropdownMenuList className={Style.CustomDropdownMenuList} closed={false}>
                                                    <div className={Style.CustomDropdownMenuListBtn} onClick={() => { setExportTo(!exportTo) }}>
                                                        <div className=""><LayoutTopIcon /> Export to</div>
                                                        <div className={`${Style.dropArrow} ${exportTo ? Style.active : null}`}><ChevronDownIcon /></div>
                                                    </div>

                                                    {
                                                        (exportTo) ? (
                                                            <div className={Style.subItemMenu}>
                                                                <CustomDropdownMenuList className={Style.subItemList} onClick={() => handleExport("csv")}>
                                                                    <div className={"d-flex align-items-center gap-1"}><FileCode1Icon /> CSV</div>
                                                                </CustomDropdownMenuList>

                                                                <CustomDropdownMenuList className={Style.subItemList} onClick={() => handleExport("excel")}>
                                                                    <div className={"d-flex align-items-center gap-1"}><FileCode1Icon /> XLSX</div>
                                                                </CustomDropdownMenuList>
                                                            </div>
                                                        ) : null
                                                    }
                                                </CustomDropdownMenuList>
                                            </CustomDropdownMenu>
                                        </CustomDropdown>
                                    </div>
                                </div>
                            </div>

                            <div className={Style.empDirectory_body}>
                                {
                                    (tableLoader) ? (
                                        (userData?.length) ? (
                                            <AnimatePresence propagate>
                                                {
                                                    (layout === "list") ? (
                                                        <div className={Style.requestCard} ref={tableRef}>
                                                            <div className={Style.scrollTable}>
                                                                {/* <table className={Style.leave_table}>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>
                                                                                <div className={Style.tableCheckBox}>
                                                                                    <label class={Style.custom_checkbox}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            ref={masterCheckboxRef}
                                                                                            className={Style.customCheckbox}
                                                                                            onChange={handleToggleAll}
                                                                                        />
                                                                                        <span class={Style.checkmark}></span>
                                                                                    </label>
                                                                                </div>
                                                                            </th>
                                                                            {
                                                                                tableHeader.map((ele, idx) => {
                                                                                    if (ele?.is_visible) {
                                                                                        if (ele?.key === "id" || ele?.key === "tenure") {
                                                                                            return (
                                                                                                null
                                                                                            )
                                                                                        } else {
                                                                                            return (
                                                                                                <th key={`th-${idx}`}>
                                                                                                    <div className={Style.tableHeading}>
                                                                                                        <span className=''>{ele?.value}</span>
                                                                                                        {
                                                                                                            (ele?.sort_by) ? (
                                                                                                                <SortIcon
                                                                                                                    field={ele?.key}
                                                                                                                    sortFields={sortFields}
                                                                                                                    onSort={handleSingleSort}
                                                                                                                    Style={Style}
                                                                                                                />
                                                                                                            ) : (
                                                                                                                <SortIcon
                                                                                                                    disabled={true}
                                                                                                                    field={ele?.key}
                                                                                                                    Style={Style}
                                                                                                                />
                                                                                                            )
                                                                                                        }
                                                                                                    </div>
                                                                                                </th>
                                                                                            )
                                                                                        }
                                                                                    } else {
                                                                                        return null;
                                                                                    }
                                                                                })
                                                                            }
                                                                        </tr>
                                                                    </thead>

                                                                    <tbody>
                                                                        {userData.map((ele, idx) => (
                                                                            <motion.tr
                                                                                key={ele.id || idx}
                                                                                initial={{ opacity: 0, y: 10 }}
                                                                                animate={{ opacity: 1, y: 0 }}
                                                                                transition={{ duration: 0.7, delay: 0.1 }}
                                                                            >
                                                                                <td>
                                                                                    <div className={Style.tableActionArea}>
                                                                                        <div className={Style.tableCheckBox}>
                                                                                            {

                                                                                                (ele?.emp_is_active === 'Active') ? (
                                                                                                    <label class={Style.custom_checkbox}>
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            className={Style.customCheckbox}
                                                                                                            checked={selectedIds.includes(ele.employee_id)}
                                                                                                            onChange={() => handleToggleOne(ele.employee_id)}
                                                                                                        />
                                                                                                        <span class={Style.checkmark}></span>
                                                                                                    </label>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        <label class={Style.custom_checkbox}>
                                                                                                            <input
                                                                                                                type="checkbox"
                                                                                                                className={Style.customCheckbox}
                                                                                                                disabled
                                                                                                            />
                                                                                                            <span class={Style.checkmark}></span>
                                                                                                        </label>
                                                                                                    </>
                                                                                                )

                                                                                            }

                                                                                        </div>

                                                                                        <div className={Style.btn} onClick={() => openAddUserData(ele)}>
                                                                                            <div className={Style.icon} style={{ color: '#d97706' }}><Pencil className="h-4.5 w-4.5" /></div>
                                                                                        </div>

                                                                                        <div className={Style.btn} onClick={() => { showEmpPopup(ele) }}>
                                                                                            <div className={Style.icon} style={{ color: '#0284c7' }}><Eye className="h-4.5 w-4.5" /></div>
                                                                                        </div>

                                                                                        <Link to={`/organization/employee-directory/${ele.id}`} className={Style.btn}>
                                                                                            <div className={Style.icon} style={{ color: '#7f22fe' }}><IdCard className="h-4.5 w-4.5" /></div>
                                                                                        </Link>
                                                                                    </div>
                                                                                </td>
                                                                                {
                                                                                    tableHeader.map((h_ele, h_idx) => {
                                                                                        if (h_ele?.is_visible) {
                                                                                            if (h_ele?.key === "id" || h_ele?.key === "tenure") {
                                                                                                return (
                                                                                                    null
                                                                                                )
                                                                                            } else if (h_ele?.key === "employee_id") {
                                                                                                return (
                                                                                                    <td key={`td-${h_idx}`}>
                                                                                                        <div className={Style.nameCell}>
                                                                                                            <span>{ele[h_ele?.key]}</span>
                                                                                                        </div>
                                                                                                    </td>
                                                                                                )
                                                                                            } else if (h_ele?.key === "profile_picture") {
                                                                                                return (
                                                                                                    <td key={`td-${h_idx}`}>
                                                                                                        <div className={Style.userProfile_sm}>
                                                                                                            {ele[h_ele?.key] ? (
                                                                                                                <img src={ele[h_ele?.key]} alt={ele?.name} />
                                                                                                            ) : (
                                                                                                                <span>
                                                                                                                    {ele?.name
                                                                                                                        ?.split(' ')
                                                                                                                        .map(w => w[0])
                                                                                                                        .slice(0, 2)
                                                                                                                        .join('')
                                                                                                                        .toUpperCase()}
                                                                                                                </span>

                                                                                                            )}
                                                                                                        </div>
                                                                                                    </td>
                                                                                                )
                                                                                            } else if (h_ele?.key === "emp_is_active") {
                                                                                                return (
                                                                                                    <td key={`td-${h_idx}`}>
                                                                                                        {
                                                                                                            (ele[h_ele?.key] === 'Active') ? (
                                                                                                                <span className={Style.active}>{ele[h_ele?.key] || '--'}</span>
                                                                                                            ) : (
                                                                                                                <span className={Style.inActive}>{ele[h_ele?.key] || '--'}</span>
                                                                                                            )
                                                                                                        }
                                                                                                    </td>

                                                                                                )
                                                                                            } else if (h_ele?.key === "tenure_value") {
                                                                                                return (
                                                                                                    <td key={`td-${h_idx}`}>
                                                                                                        {ele?.tenure || '--'}
                                                                                                    </td>
                                                                                                )
                                                                                            } else if (h_ele?.key === "email" || h_ele?.key === "p_personal_email") {
                                                                                                return (
                                                                                                    <td key={`td-${h_idx}`}>
                                                                                                        <a href={`mailto:${ele[h_ele?.key]}` || ''}>
                                                                                                            {ele[h_ele?.key] || '--'}
                                                                                                        </a>
                                                                                                    </td>
                                                                                                )
                                                                                            } else {
                                                                                                return (
                                                                                                    <td key={`td-${h_idx}`}>
                                                                                                        {ele[h_ele?.key] || '--'}
                                                                                                    </td>
                                                                                                )
                                                                                            }
                                                                                        } else {
                                                                                            return null;
                                                                                        }
                                                                                    })
                                                                                }
                                                                            </motion.tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table> */}
                                                                <MainTable 
                                                                    tableHeader={tableHeader}
                                                                    userData={userData}
                                                                    isCheckBox={{isShow: true, ref: masterCheckboxRef, func: handleToggleAll, selectedIds: selectedIds, handleToggleOne: handleToggleOne}}
                                                                    isSort={{isShow: true, func: handleSingleSort, sortFields: sortFields}}
                                                                    isEdit={{isShow: true, func: openAddUserData}}
                                                                    isView={{isShow: true, func: showEmpPopup}}
                                                                    isRedirect={{isShow: true, url: "/organization/employee-directory/", eleKey: "id"}}
                                                                    hiddenFields={["id", "tenure"]}
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (layout === "grid") ? (
                                                        <div className={Style.team_grid}>
                                                            {userData.map((m, i) => (
                                                                <motion.div
                                                                    className={Style.team_cardMain}
                                                                    key={m.id}
                                                                    initial={{ opacity: 0, x: 20 }}
                                                                    animate={{ opacity: 1, x: 0 }}
                                                                    exit={{ opacity: 0, x: -20 }}
                                                                    transition={{ duration: 0.3, delay: Math.min((i * 0.15) + 0.5, 2) }}
                                                                >
                                                                    <Link to={`/organization/employee-directory/${m.id}`} className={Style.team_card}>
                                                                        <div className={Style.team_card__avatar_wrap}>
                                                                            {m.profile_picture ? (
                                                                                <img src={m.profile_picture} className={Style.team_card__avatar} alt={m.name} />
                                                                            ) : (
                                                                                <span>
                                                                                    {m?.name
                                                                                        ?.split(' ')
                                                                                        .map(w => w[0])
                                                                                        .slice(0, 2)
                                                                                        .join('')
                                                                                        .toUpperCase()}
                                                                                </span>
                                                                            )}
                                                                        </div>

                                                                        <div className={Style.team_card__content}>
                                                                            <div>
                                                                                <div className={Style.team_card__name}>{m.name || '--'}</div>
                                                                                <div className={Style.team_card__id}>{m.employee_id || '--'}</div>
                                                                            </div>

                                                                            <div>
                                                                                <div className={Style.team_card__role}>
                                                                                    {(m.emp_is_active == "InActive") ?
                                                                                        <span className={Style.inActive} style={{ width: "fit-content", padding: "2px 10px", fontSize: 12 }}>{m.emp_is_active}</span>
                                                                                        :
                                                                                        <span className={Style.active} style={{ width: "fit-content", padding: "2px 10px", fontSize: 12 }}>{m.emp_is_active}</span>
                                                                                    }

                                                                                </div>

                                                                                {/* {
                                                                                    (ele[h_ele?.key] === 'Active') ? (
                                                                                        <span className={Style.active}>{ele[h_ele?.key] || '--'}</span>
                                                                                    ) : (
                                                                                        <span className={Style.inActive}>{ele[h_ele?.key] || '--'}</span>
                                                                                    )
                                                                                } */}
                                                                                <div className={Style.team_card__role}>{m.date_of_joining || '--'}</div>
                                                                                <div className={Style.team_card__email}>{m.email || '--'}</div>
                                                                                <div className={Style.team_card__dept}>{m.emp_designation || '--'}</div>
                                                                            </div>

                                                                            <div>
                                                                                <div className={Style.team_card__checkin}>{m.department_name || '--'}</div>
                                                                                <div className={Style.team_card__team}>{m.reporting_authority_name || "--"}</div>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                </motion.div>
                                                            ))}
                                                        </div>
                                                    ) : (layout === "grid2") ? (
                                                        <div className={Style.team_grid2}>
                                                            {userData.map((m, i) => (
                                                                <motion.div
                                                                    className={Style.team2_cardMain}
                                                                    key={`${m.id}-g2`}
                                                                    initial={{ opacity: 0, x: 20 }}
                                                                    animate={{ opacity: 1, x: 0 }}
                                                                    exit={{ opacity: 0, x: -20 }}
                                                                    transition={{ duration: 0.3, delay: Math.min((i * 0.15) + 0.5, 2) }}
                                                                >
                                                                    <div className={Style.team2_card}>
                                                                        <div className={Style.team2_card__head}>
                                                                            <div className={Style.team2_card__avatar_wrap}>
                                                                                {m.profile_picture ? (
                                                                                    <img src={m.profile_picture} className={Style.team2_card__avatar} alt={m.name} />
                                                                                ) : (
                                                                                    <span>
                                                                                        {m?.name
                                                                                            ?.split(' ')
                                                                                            .map(w => w[0])
                                                                                            .slice(0, 2)
                                                                                            .join('')
                                                                                            .toUpperCase()}
                                                                                    </span>
                                                                                )}
                                                                            </div>

                                                                            <div className={Style.team2_card__head_content}>
                                                                                <h6>{m.name || '--'}</h6>
                                                                                <a href={`mailto:${m.email}` || ''}>{m.email || '--'}</a>

                                                                                <h5>{m.department_name || '--'}</h5>
                                                                                <p>{m.emp_designation || '--'}</p>
                                                                                {(m.emp_is_active == "InActive") ?
                                                                                    <span className={Style.inActive} style={{ width: "fit-content", padding: "3px 10px", fontSize: 12 }}>{m.emp_is_active}</span>
                                                                                    :
                                                                                    <span className={Style.active} style={{ width: "fit-content", padding: "3px 10px", fontSize: 12 }}>{m.emp_is_active}</span>
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                        <div className={Style.team2_card__body}>
                                                                            <h6>
                                                                                <span>Employee ID</span>
                                                                                <b>{m.employee_id || '--'}</b>
                                                                            </h6>
                                                                            <h6>
                                                                                <span>Date of Joining</span>
                                                                                <b>{m.date_of_joining || '--'}</b>
                                                                            </h6>
                                                                            <div className={Style.lineBreak}></div>
                                                                            <h6>
                                                                                <span>Reporting</span>
                                                                                <b>{m.reporting_authority_name || '--'}</b>
                                                                            </h6>
                                                                            <h6>
                                                                                <span>Salary</span>
                                                                                <b>
                                                                                    <div className="icon">

                                                                                    </div>
                                                                                    {m.emp_salary || '--'}
                                                                                </b>
                                                                            </h6>
                                                                        </div>

                                                                        <div className={Style.team2_card__foot}>
                                                                            <div className={Style.team2_card_btnGroup}>
                                                                                <div className={Style.team2_card_btn} onClick={() => openAddUserData(m)}>
                                                                                    <div className={Style.icon}>
                                                                                        <Edit2Icon />
                                                                                    </div>
                                                                                </div>

                                                                                <Link to={`/organization/employee-directory/${m.id}`} className={Style.team2_card_btn}>
                                                                                    <div className={Style.icon}>
                                                                                        <UserSquareIcon />
                                                                                    </div>
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </motion.div>
                                                            ))}
                                                        </div>
                                                    ) : null
                                                }
                                            </AnimatePresence>
                                        ) : (
                                            <DataNotFound title={"User's"} />
                                        )
                                    ) : (
                                        <InnerLoader />
                                    )
                                }
                            </div>

                            {
                                (tableLoader) ? (
                                    <div className={Style.table_footer} style={{ alignItems: 'center' }}>
                                        <div className={Style.table_footer_left}>
                                            {/* {
                                                (pageItemsCount === 'all') ? (
                                                    `Showing 1 to ${userData.length} of ${userData.length}`
                                                ) : (
                                                    `showing ${(tablePagination?.current_page - 1) * pageItemsCount + 1} to ${Math.min(tablePagination?.current_page * pageItemsCount, tablePagination?.total)} of ${tablePagination?.total} entries`
                                                )
                                            } */}

                                            {`showing 1 to ${userData?.length} of ${tablePagination?.total || userData?.length}`}

                                        </div>

                                        {
                                            (tablePagination) ? (
                                                <div className={Style.empDirectory_footer}>
                                                    {/* <Pagination
                                                        pagination={tablePagination}
                                                        onPageChange={(page) => {
                                                            filterData({ page });
                                                            setPageCount(page)
                                                        }}
                                                    /> */}
                                                    {
                                                        (userData?.length != tablePagination?.total && pageItemsCount != "all") ?
                                                            <button className={Style.loadMoreBtn} onClick={() => {
                                                                if (btnLoader) return;
                                                                setPageCount(pageCount + 1);
                                                                setBtnLoader(true);
                                                                filterData({ page: pageCount + 1, btnCall: true });
                                                            }}>
                                                                {
                                                                    (btnLoader) ?
                                                                        <InnerLoader className={Style.loader} textStatus={false} />
                                                                        : 'Load More'
                                                                }
                                                            </button>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            ) : null
                                        }

                                        <div className={`${Style.table_footer_left} ${Style.rightText}`}>
                                            {/* {
                                                (pageItemsCount === 'all') ? (
                                                    'Page 1 of 1'
                                                ) : (
                                                    `Page ${tablePagination?.current_page} of ${tablePagination?.last_page}`
                                                )
                                            } */}

                                        </div>
                                    </div>
                                ) : (
                                    <div className={Style.table_footer} style={{ alignItems: 'center' }}>
                                        <div className={Style.table_footer_left}>
                                            <Skeleton width={'50%'} height={15} />
                                        </div>

                                        <div className={Style.empDirectory_footer}>
                                            <Skeleton width={'180px'} height={40} />
                                        </div>

                                        <div className={`${Style.table_footer_left} ${Style.rightText}`}>
                                            {/* <Skeleton width={'100%'} height={15} /> */}
                                        </div>
                                    </div>
                                )
                            }

                        </div>
                    </div>
                </div>
            </div>

            {showModalFilterTable &&
                <FilterTabsPopup
                    data={tableFilter}
                    onClose={() => setShowModalFilterTable(false)}
                    returnData={filterReturn}
                    onSave={(filters, filterName, editingFilter) => {
                        setShowModalFilterTable(false)
                        setFilterReturn(filters);
                        setSelectFilterName(filterName)
                        setEditingFilters(editingFilter)
                        setPageCount(1);
                        filterData({ filters: filters, page: 1 });
                    }}
                    saveFilter={saveFilter}
                    apiUrl="get-all-employees"
                    selectFilterName={selectFilterName}
                    editingFilters={editingFilters}
                />
            }

            {addUser &&
                <EmployeeDirectoryAddUpdate
                    onClose={() => { setAddUser(false); setAddUserData({}); }}
                    onChange={() => { filterData({ filters: filterReturn, page: pageCount, page_quantity: pageItemsCount }); }}
                    data={addUserData}
                />
            }

            {showModalCustomizeTabs &&
                <CustomizeTabsPopup
                    data={tableHeader}
                    onClose={() => {
                        setShowModalCustomizeTabs(false);
                        const table = tableRef?.current;
                        if (table) {
                            table.style.zIndex = 1;
                        }
                    }}
                    onPreview={(updatedHeaders) => {
                        setTableHead(updatedHeaders);
                        const table = tableRef?.current;
                        table.style.zIndex = 100;
                    }}
                    onPreviewClose={() => {
                        const table = tableRef?.current;
                        table.style.zIndex = 1;
                    }}
                    onSave={(saveHeaders) => {
                        setTableHead(saveHeaders);
                        const table = tableRef?.current;
                        if (table) {
                            table.style.zIndex = 1;
                        }
                    }}
                    apiUrl="get-all-employees"
                />
            }

            {empPopup &&
                <EmployeeQuickView
                    onClose={() => { setEmpPopup(false); setEmpData({}); }}
                    data={empData}
                />
            }

            {bulkDataChange &&
                <EmployeeUpdateBulk
                    data={selectedIds}
                    onClose={() => { setBulkDataChange(false); setBulkDatavalue('') }}
                    onChange={() => { setBulkDatavalue('') }}
                />
            }
        </>
    )
}

export default OrganizationEmployeeDirectory




